import React from 'react';
import AuthService from '../services/AuthService';
import InitialHome from './InitialHome';
import Dashboard from '../dashboard/Dashboard';

const Home: React.FC = () => {
    if (AuthService.isTokenExpired()) {
        return (<InitialHome />)
    }
    else {
        return (<Dashboard />);
    }
};

export default Home;